/* global axios */
import ApiClient from '../ApiClient';

// Fila de Criticidade (M8): conversas ativas ordenadas por risco. Recurso singular.
class CriticidadeAPI extends ApiClient {
  constructor() {
    super('fandata/criticidade', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }
}

export default new CriticidadeAPI();
